import { useEffect, useState } from "react";

export const SEARCH_MIN_LENGTH = 3;
export const SEARCH_DEBOUNCE_MS = 800;

export function useDebouncedValue(value, delay = SEARCH_DEBOUNCE_MS) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    if (value === "" || value === "[]") {
      setDebouncedValue(value);
      return undefined;
    }
    const timeoutId = window.setTimeout(() => setDebouncedValue(value), delay);
    return () => window.clearTimeout(timeoutId);
  }, [delay, value]);
  return debouncedValue;
}

export function hasSearchText(value) {
  return String(value || "").trim().length >= SEARCH_MIN_LENGTH;
}

export function useAdminTextSearch(value) {
  const trimmedValue = String(value || "").trim();
  const [debouncedValue, setDebouncedValue] = useState(() =>
    hasSearchText(trimmedValue) ? trimmedValue : ""
  );

  useEffect(() => {
    if (!trimmedValue || !hasSearchText(trimmedValue)) {
      setDebouncedValue("");
      return undefined;
    }

    const timeoutId = window.setTimeout(
      () => setDebouncedValue(trimmedValue),
      SEARCH_DEBOUNCE_MS
    );
    return () => window.clearTimeout(timeoutId);
  }, [trimmedValue]);

  return {
    value: debouncedValue,
    isTooShort: trimmedValue.length > 0 && !hasSearchText(trimmedValue),
  };
}
